import React, { useState } from "react";
import "./App.css";
import "./redesign.css";
import Logo from "./logo/Plevel_design_horizontal.png";
import LogoWhite from "./logo/Plevel_design_horizontal_white-01.png";
import Navigation from "./components/navigation.js";
import Gallery from "./components/gallery.js";
import Pampeliska from "./components/pampeliska.js";
import ProjectCard from "./components/projectCard.js";


function App() {
  
  
  
  
  const about = [
    {
      heading: "O mně",
      subheading: null,
      text: "Jmenuji se Anežka a pracuji s lidmi, kteří chtějí, aby jejich místo vypadalo živě – ne uměle, ne nákladně na údržbu, ne jako kopie sousedovy zahrady. Od roku 2012 navrhuji zeleň pro soukromé zahrady i celé obce. Každý projekt řeším v kontextu místa: co tam roste přirozeně, jak tam fouká vítr, co přijde za dvacet let s klimatem.", 
      photo: "/photos/Anezka/anešaupravena.jpg",
    },
    {
      heading: null,
      subheading: null,
      text: "Jezdím z Kozlovic na Frýdecko-Místecku. Většinu projektů mám na Moravě, ale pracuji i jinde – výjezdy mimo region jen trochu víc plánuju dopředu. Pokud řešíte více lokalit nebo větší území, ráda to zkombinuji do jedné návštěvy.", 
      photo: null,
    },
  ];
  
  const listofservice = [
    {
      heading: null,
      subheading: "Co pro vás můžu udělat",
      text: null, 
      photo: null,
    },

  ];

    const colab = [
    {
      heading: null,
      subheading: "Jak funguje spolupráce?",
      text: "Začneme krátkým hovorem nebo e-mailem – sladíme, co potřebujete vy a co umím já. Pak se potkáme na pozemku. První konzultace zpravidla trvá 1–2 hodiny: projdeme místo, proberete mi svou vizi, já se zeptám na vše potřebné.\n\nDo dvou dnů dostanete e-mailem návrh cenového rámce a termín dodání projektu. Některé spolupráce končí předáním dokumentace. Jiné trvají roky – vracím se na pozemek, sleduji, jak se výsadba vyvíjí, jsem na telefonu v případě nutnosti rychlých konzultací, navrhuji akční kroky a vylepšení, nabízím také odbornou údržbu.", 
      photo: null,
    },
  ];
    const experience = [
      {
        heading: null,
        subheading: "Co stojí za mým přístupem",
        text: null, 
        photo: null,
      },
    ];
    const whyplevel = [
      {
        heading: null,
        subheading: null,
        text: "Plevel není problém k vyřešení. Je to signál – o půdě, o vlhkosti, o tom, co místo potřebuje. Stejně tak přistupuji ke každému pozemku: nejdřív poslouchám, pak navrhuji.", 
        photo: null,
      },
    ];


  const service = [
    {
      heading: "Zpracování projektu",
      text: "Dostanete kompletní podklad pro realizaci – analýzu lokality, osazovací plán, správné postupy a popis péče. Cena závisí na velikosti a náročnosti; zahrada do 1 000 m² vychází orientačně na 15 000–20 000 Kč. Rok po předání jsem dostupná na konzultace e-mailem.",
    },
    {
      heading: "Konzultace",
      text: "Když ještě nevíte, jestli projekt chcete – nebo když ho máte a něco nefunguje. Přijedu, projdeme místo spolu a odejdete s konkrétními odpověďmi. 900 Kč/hod + doprava 8 Kč/km.",
    },
    {
      heading: "Realizace - zahrady",
      text: "Výsadba rostlin, úprava stanoviště, skalky, mulčování. Jsem u toho fyzicky – ne jen na papíře. Součástí může být i pravidelná odborná údržba, například řez dřevin. Nezajišťuji zpevněné plochy ani sekání trávníku.",
    },
    {
      heading: "Realizace - pro obce",
      text: "Výsadba stromů a trvalek ve větším měřítku – aleje, návsi, veřejná zeleň. Zajišťuji i následnou péči, aby se výsadba skutečně ujala a sloužila mnoho let po založení.",
    },
    {
      heading: "Řez stromů",
      text: "Každé předjaří se věnuji výchovnému řezu mladých stromů a omlazujícímu řezu vzrostlých – nejčastěji ovocných. Přijedu s žebříkem na stromy dostupné bez stromolezeckého vybavení, což většině zahrad a sadů stačí. 1000 Kč/hod + doprava 8 Kč/km. Na opravdu vysoké stromy pak ráda doporučím ověřeného kolegu arboristu-stromolezce.",
    },

  ];

  const portfolio = [
    {
      location: "Komunitní zahrada Pod Velkým Hájem, Praha-Krč 2025",
      description:
        "Koncepční zahradně-architektonická studie pro největší komunitní zahradu v České republice. Projekt v městském prostředí Prahy-Krče s důrazem na sdílení prostoru, jedlou krajinu a dlouhodobou udržitelnost — navrhnout pro desítky uživatelů s různými potřebami znamená myslet na detail i celek.",
      photo: [
        {
          src: "/photos/portfolio/2025 -X Komunitní zahrada Pod Velkým Hájem Praha Krč/20251006_104114.jpg",
          legend: "Velký Háj, Praha-Krč 2025",
        },
        {
          src: "/photos/portfolio/2025 -X Komunitní zahrada Pod Velkým Hájem Praha Krč/20260513_181022.jpg",
          legend: "Velký Háj, Praha-Krč 2025",
        },
        {
          src: "/photos/portfolio/2025 -X Komunitní zahrada Pod Velkým Hájem Praha Krč/20260513_190417.jpg",
          legend: "Velký Háj, Praha-Krč 2025",
        },
        {
          src: "/photos/portfolio/2025 -X Komunitní zahrada Pod Velkým Hájem Praha Krč/20260513_190421.jpg",
          legend: "Velký Háj, Praha-Krč 2025",
        },
        {
          src: "/photos/portfolio/2025 -X Komunitní zahrada Pod Velkým Hájem Praha Krč/20260513_190423.jpg",
          legend: "Velký Háj, Praha-Krč 2025",
        },
      ],
    },
    {
      location: "Rodinná zahrada Frenštát 2025",
      description:
        "Návrh rodinné zahrady na Frenštátsku. Důraz na odolnost vůči klimatickým výkyvům, soběstačnost a estetiku — funkční místo, ve kterém zahrada není dekorace, ale součást každodenního života rodiny.",
      photo: [
        {
          src: "/photos/portfolio/2025 Rodinná zahrada Frenštát/20251016_131034.jpg",
          legend: "Frenštát 2025",
        },
        {
          src: "/photos/portfolio/2025 Rodinná zahrada Frenštát/20251016_131054.jpg",
          legend: "Frenštát 2025",
        },
      ],
    },
    {
      location: "Naše zahrada Chotětov 2019",
      description:
        "V roce 2019 jsme se nastěhovali do domu, který měl místo zahrady pouze 350m2 staveniště. Postupně jsme jej začali svépomocí předělávat v místo plné života. Přibylo k nám druhé a třetí dítě, oba s mužem pracujeme, takže vysoká míra bezúdržbovosti a samoregulace je pro nás zásadní.",
      photo: [
        {
          src: "/photos/portfolio/Naše zahrada Chotětov 2019/Chotetov_nase_1.jpg",
          legend: "Chotětov 2019",
        },
        {
          src: "/photos/portfolio/Naše zahrada Chotětov 2019/Chotetov_nase_2.jpg",
          legend: "Chotětov 2019",
        },
        {
          src: "/photos/portfolio/Naše zahrada Chotětov 2019/Chotetov_nase_3.jpg",
          legend: "Chotětov 2019",
        },
        {
          src: "/photos/portfolio/Naše zahrada Chotětov 2019/Chotetov_nase_4.JPG",
          legend: "Chotětov 2019",
        },
        {
          src: "/photos/portfolio/Naše zahrada Chotětov 2019/Chotetov_nase_5.JPG",
          legend: "Chotětov 2019",
        },
        {
          src: "/photos/portfolio/Naše zahrada Chotětov 2019/Chotetov_nase_6.JPG",
          legend: "Chotětov 2019",
        },
        {
          src: "/photos/portfolio/Naše zahrada Chotětov 2019/Chotetov_nase_7.JPG",
          legend: "Chotětov 2019",
        },
        {
          src: "/photos/portfolio/Naše zahrada Chotětov 2019/Chotetov_nase_8.JPG",
          legend: "Chotětov 2019",
        },
        {
          src: "/photos/portfolio/Naše zahrada Chotětov 2019/Chotetov_nase_9.JPG",
          legend: "Chotětov 2019",
        },
      ],
    },
    {
      location: "LIBEREC 2020",
      description:
        "U této zahrady bylo potřeba nejprve vyřešit prudký svah a jeho následné zpevnění. Zahrada měla být hodně orientovaná na děti a samozásobitelství, ale zároveň zde nemohly být žádné alergie působící rostliny, což byl trošku oříšek. Nakonec se nám podařilo vymyslet funkční kompromis pro všechny uživatele zahrady. ",
      photo: [
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_1.jpeg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_2.jpeg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_3.jpeg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_4.jpeg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_5.jpeg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_6.jpeg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_7.jpeg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_8.jpeg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_9.jpeg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_10.jpg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_11.jpg",
          legend: "Liberec 2020",
        },
        {
          src: "/photos/portfolio/Liberec 2020/Liberec_12.jpeg",
          legend: "Liberec 2020",
        },
      ],
    },
    {
      location: "Lesní klub Mondík 2021",
      description:
        "Se spolkem Mondík jsem začala spolupracovat v roce 2019. Mají v pronájmu kus farní zahrady pro své aktivity (zejména pobyt dětí z lesního klubu 3 dny v týdnu). Zahrada byla velmi zarostlá, postupně se kultivovala, avšak kvůli velmi prudkému svahu bylo potřeba udělat větší zásahy. Ty jsem měla na starosti já. Bez větší finanční injektáže by to bohužel nešlo, proto jsme společně zažádali o dotace na \"Zelené oázy\" nadace Partnerství. Na jaře 2021 nám dotaci přidělili a pustili jsme se do práce. Bohužel kvůli protiepidemickým opatřením byly akce a brigády v jiném formátu než jsme si představovali, nakonec jsme ale do konce roku vše stihli dokončit za pomocí 2 brigádníků.",
      photo: [
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_01.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_02.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_03.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_04.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_05.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_06.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_07.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_08.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_09.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_10.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_11.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_12.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_13.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_14.jpg",
          legend: "Benátky nad Jizerou 2021",
        },
        {
          src: "/photos/portfolio/Lesní klub Mondík 2021/Mondik_15.jpg",
          legend: "Benátky nad Jizerou 2021",
        },

      ],
    },
    {
      location: "DOLNÍ BOUSOV 2020",
      description:
        "Klasické zadání: zahrada cca 1000m2 u novostavby, momentálně celá rozkopaná bez jakékoli zeleně. A přeci je každá jiná! Tato je specifická precizním provedením - samorealizace - a potřebou upraveného pocitu ze zahrady. I takto může v praxi vypadat přírodní design!",
      photo: [
        {
          src: "/photos/portfolio/Ječná Dolní Bousov 2021/Bousov_01.jpg",
          legend: "Dolní Bousov 2020",
        },
        {
          src: "/photos/portfolio/Ječná Dolní Bousov 2021/Bousov_02.jpg",
          legend: "Dolní Bousov 2020",
        },
        {
          src: "/photos/portfolio/Ječná Dolní Bousov 2021/Bousov_03.jpg",
          legend: "Dolní Bousov 2020",
        },
        {
          src: "/photos/portfolio/Ječná Dolní Bousov 2021/Bousov_04.jpg",
          legend: "Dolní Bousov 2020",
        },
        {
          src: "/photos/portfolio/Ječná Dolní Bousov 2021/Bousov_05.jpg",
          legend: "Dolní Bousov 2020",
        },
        {
          src: "/photos/portfolio/Ječná Dolní Bousov 2021/Bousov_06.jpg",
          legend: "Dolní Bousov 2020",
        },
        {
          src: "/photos/portfolio/Ječná Dolní Bousov 2021/Bousov_07.jpg",
          legend: "Dolní Bousov 2020",
        },
        
      ],
    },
    {
      location: "CHOTĚTOV 2020",
      description:
        "Spolupráce na této zahradě byla specifická v tom, že měli zahradu již několik let založenou. Nějakou dobu už se v ní ale necítili dobře, něco jí chybělo. Proto jsme se sešli, probrali způsob jakým ji momentálně využívají a co by se mělo změnit do budoucna. Naprosto klíčovým prvkem bylo nově založené koupací jezírko (celoročně, jsou to nadšení otužilci). Původní vize byl jen smáčecí sud, ale nakonec jsme se dohodli na jezírku 6x4m a byla to správná volba. Přidali jsme také skalku pro bylinky a schování poklopů pro dešťovku, na celou zahradu pak obrubníky a plošný mulč plný celoročně kvetoucích trvalek. K tomu také 2 vysokokmeny a dominantní vícekmen javoru k jezírku doplněný barevnou lavičkou - zde jsem musela chvíli přesvědčovat, ale jsem ráda, že jsem byla úspěšná. :)",
      photo: [
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_1.jpeg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_2.jpeg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_3.jpeg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_3.jpeg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_4.jpeg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_5.jpeg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_6.jpeg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_7.jpg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_8.jpg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_9.jpg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_10.jpg",
          legend: "Chotětov 2020",
        },
        {
          src: "/photos/portfolio/Chotětov 2020/Chotetov_11.JPG",
          legend: "Chotětov 2020",
        },       
      ],
    },
    {
      location: "Diplomová práce - Hospodářství LÍŠNICE",
      description:
        "Spolupráce s Víťou a Luckou Kulhánkovými započala v roce 2013, kdy jsem hledala pozemek vhodný pro analýzu a vytvoření projektového permakulturního designu pro mou diplomovou práci. Kromě pozemku jsem našla také úžasně inspirativní lidi, se kterými se vídám až do současnosti. Jejich pragmatický přístup k permakultuře a postupné realizaci byl jako stvořený k racionálnímu akademickému postupu. Pozemek má rozlohu 3,2 ha, z toho 0,8 ha tvoří rybník. Zbytek pozemku se nachází na JZ svahu a v minulosti byl využíván zpočátku jako pole, později jako trvalý travní porost s šetrným obhospodařováním. Záměrem majitelů je se na pozemek v horizontu 10 let přestěhovat. V plánu je vybudování ekologického domu zapuštěného do svahu a užitkové zahrady/usedlosti se zaměřením na soběstačnost jak v rostlinné tak živočišné produkci. Podrobněji viz diplomová práce - na vyžádání prostřednictvím emailu. Na pozemku byla také v roce 2015 uspořádaná praktická část mezinárodní letní škola Permaculture and Science (fotky viz speciální složka).",
      photo: [
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_1.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_2.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_3.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_4.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_5.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_6.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_7.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_8.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_9.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_10.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_11.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_12.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_13.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_14.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_15.jpg",
          legend: "Líšnice 2014 - současnost",
        },
        {
          src: "/photos/portfolio/Líšnice 2016/Lisnice_16.jpg",
          legend: "Líšnice 2014 - současnost",
        },
      ],  
    },
    {
      location: "KOZLOVICE 2012",
      description:
        "Experimentální pozemek u mých rodičů, o rozloze cca 1000m2. Zeleninové vyvýšené záhony, bylinková spirála, podpůrné byliny a keře u ovocných stromů, zakomponování pařeniště, trojkomorový kompostér. Jedlé stromy, keře, byliny, houby. Tříletý pokus o přírodní jezírko nakonec skončil ztrátou nervů a vyložením ekologickou jezírkovou folií - ne každý má štěstí na dostatečnou jílovitou složku v půdě.",
      photo: [
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_1.JPG",
          legend: "Kozlovice 2012 - současnost",
        },
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_2.JPG",
          legend: "Kozlovice 2012 - současnost",
        },
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_3.JPG",
          legend: "Kozlovice 2012 - současnost",
        },
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_4.JPG",
          legend: "Kozlovice 2012 - současnost",
        },
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_5.jpg",
          legend: "Kozlovice 2012 - současnost",
        },
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_6.jpg",
          legend: "Kozlovice 2012 - současnost",
        },
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_7.JPG",
          legend: "Kozlovice 2012 - současnost",
        },
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_8.JPG",
          legend: "Kozlovice 2012 - současnost",
        },
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_9.JPG",
          legend: "Kozlovice 2012 - současnost",
        },
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_10.jpg",
          legend: "Kozlovice 2012 - současnost",
        },
        {
          src: "/photos/portfolio/Kozlovice 2012/Kozlovice_11.jpg",
          legend: "Kozlovice 2012 - současnost",
        },    
      ],
    },
    {
      location: "Realizace sadu JABLONNÉ V PODJEŠTĚDÍ 2019",
      description:
        "Postupná realizace pozemku o rozloze 8000m2 ve svahu na úpatí Jizerských hor. V prudkém svahu bylo nutné vybudování svejlů pro zadržování vody i živin pro ovocné stromy. Zároveň zde byla velká limitace elektrickým vedením nad samotným sadem.",
      photo: [
        {
          src: "/photos/portfolio/Realizace sadu Jablonné v Podještědí 2019/Podjestedi_1.JPG",
          legend: "Jablonné v Podještědí",
        },
        {
          src: "/photos/portfolio/Realizace sadu Jablonné v Podještědí 2019/Podjestedi_2.JPG",
          legend: "Jablonné v Podještědí",
        },
        {
          src: "/photos/portfolio/Realizace sadu Jablonné v Podještědí 2019/Podjestedi_3.JPG",
          legend: "Jablonné v Podještědí",
        },
        {
          src: "/photos/portfolio/Realizace sadu Jablonné v Podještědí 2019/Podjestedi_4.JPG",
          legend: "Jablonné v Podještědí",
        },
        {
          src: "/photos/portfolio/Realizace sadu Jablonné v Podještědí 2019/Podjestedi_5.JPG",
          legend: "Jablonné v Podještědí",
        },
      ],
    },
    {
      location: "Project ECLS kompletní návrh farmy 2015",
      description:
        "Case study competition zrealizovaná v rámci ČZU v roce 2015. V rámci půlroku se mezinárodní týmy studentů zaobíraly konkrétní farmou v obci Klášterní Skalice o rozloze cca 98ha. Během několikaměsíční teoretické přípravy a následně týdenního pobytu na farmě bylo úkolem vypracovat kompletní plán pro inovace farmy (rostlinná i živočišná produkce) na několik let dopředu včetně financování, marketingu a vlastní značky. Výsledky pak byly prezentovány na konferenci v Praze, kde naše skupina vyhrála studentskou cenu.",
      photo: [
        {
          src: "/photos/portfolio/ECLS case study competition 2015/ECLS_2.jpg",
          legend: "Klášterní Skalice",
        },
        {
          src: "/photos/portfolio/ECLS case study competition 2015/ECLS_3.jpg",
          legend: "Klášterní Skalice",
        },
        {
          src: "/photos/portfolio/ECLS case study competition 2015/ECLS_4.jpg",
          legend: "Klášterní Skalice",
        },
      ],
    },
    {
      location: "Letní škola Permaculture and Science 2015",
      description:
        "Mnou organizovaná letní škola na ČZU s mezinárodními lektory i účastníky. 27. 7. - 2. 8. 2015. Teoretická část proběhla na České zemědělské univerzitě, praktická pak no pozemku v Líšnici u manželů Kulhánkových (viz Hospodářství Líšnice).",
      photo: [
        {
          src: "/photos/portfolio/Permaculture and Science 2015/Perma_science_1.JPG",
          legend: null,
        },
        {
          src: "/photos/portfolio/Permaculture and Science 2015/Perma_science_2.JPG",
          legend: null,
        },
        {
          src: "/photos/portfolio/Permaculture and Science 2015/Perma_science_3.JPG",
          legend: null,
        },
        {
          src: "/photos/portfolio/Permaculture and Science 2015/Perma_science_4.JPG",
          legend: null,
        },
        {
          src: "/photos/portfolio/Permaculture and Science 2015/Perma_science_5.JPG",
          legend: null,
        },
        {
          src: "/photos/portfolio/Permaculture and Science 2015/Perma_science_6.JPG",
          legend: null,
        },
        {
          src: "/photos/portfolio/Permaculture and Science 2015/Perma_science_7.JPG",
          legend: null,
        },
        {
          src: "/photos/portfolio/Permaculture and Science 2015/Perma_science_8.JPG",
          legend: null,
        },
        {
          src: "/photos/portfolio/Permaculture and Science 2015/Perma_science_9.jpg",
          legend: null,
        },
        {
          src: "/photos/portfolio/Permaculture and Science 2015/Perma_science_10.JPG",
          legend: null,
        },
      ],
    },
    {
      location: "HORNÍ LOUČKY 2015",
      description:
        "Zahrada pro malé děti, samozásobitelství a odpočinek s využitím velkého množství permakulturních prvků.",
      photo: [
        {
          src: "/photos/portfolio/Horní Loučky 2016/Loucky_01.jpg",
          legend: "Horní Loučky",
        },
        {
          src: "/photos/portfolio/Horní Loučky 2016/Loucky_02.jpg",
          legend: "Horní Loučky",
        },
        {
          src: "/photos/portfolio/Horní Loučky 2016/Loucky_03.jpg",
          legend: "Horní Loučky",
        },
        {
          src: "/photos/portfolio/Horní Loučky 2016/Loucky_04.jpg",
          legend: "Horní Loučky",
        },
        {
          src: "/photos/portfolio/Horní Loučky 2016/Loucky_05.jpg",
          legend: "Horní Loučky",
        },
        {
          src: "/photos/portfolio/Horní Loučky 2016/Loucky_06.jpg",
          legend: "Horní Loučky",
        },
        {
          src: "/photos/portfolio/Horní Loučky 2016/Loucky_07.jpg",
          legend: "Horní Loučky",
        },
        {
          src: "/photos/portfolio/Horní Loučky 2016/Loucky_08.jpg",
          legend: "Horní Loučky",
        },
      ],
    },
    {
      location: "LÍSKOVEC 2013",
      description:
        "Pozemek o rozloze cca 1,5ha - 0,5ha užitková zahrada a 1ha pastvina s jedlými keři a stromy. Valná část pozemku se nachází na jižním svahu, uprostřed něhož je vybudovaná vodní plocha napájená dešťovou vodou ze střechy výše položeného domu. Na pozemku je jílovité podloží a umístění bylo vybráno optimálně, jezírko tedy bylo zcela přírodní a samoregulované.",
      photo: [
        {
          src: "/photos/portfolio/Lískovec 2013/Liskovec_1.JPG",
          legend: "Lískovec",
        },
        {
          src: "/photos/portfolio/Lískovec 2013/Liskovec_2.JPG",
          legend: "Lískovec",
        },
        {
          src: "/photos/portfolio/Lískovec 2013/Liskovec_3.JPG",
          legend: "Lískovec",
        },
        {
          src: "/photos/portfolio/Lískovec 2013/Liskovec_4.JPG",
          legend: "Lískovec",
        },
        {
          src: "/photos/portfolio/Lískovec 2013/Liskovec_5.jpg",
          legend: "Lískovec",
        },
      ],
    },
  ];

  const reference = [
    {
      heading: "",
      text: "Klasická zahrada s trávníkem nás nikdy nenadchla. S Anežkou jsme se vydaly jiným směrem – a zahrada konečně vypadá tak, jak jsme chtěly.",
      name: "Jana Midrlová",
    },
    {
      heading: "",
      text: "Letní škola permakultury, kterou Anežka pořádala s ČZU a lektory z Wageningenu, byla výjimečná tím, že spojila akademický svět s praxí. Získala jsem pohled z velmi různých stran najednou.",
      name: "Markéta Mikovcová",
    },
    {
      heading: "",
      text: "28 let jsme hledali cestu, jak skloubit zeleninu a zahradu s parkovou úpravou. Permakultura nás oslovila – a Anežka nám ukázala, jak na to.",
      name: "Lenka Tkáčová",
    },
    {
      heading: "",
      text: "Měli jsme velkou zahradu a mlhavou představu. Anežka z toho udělala plán, který dává smysl – a který zvládneme realizovat postupně sami.",
      name: "Blanka Brandová",
    },
    {
      heading: "",
      text: "Jsem velmi spokojená - s Anežkou je skvělá domluva, návrh zahrady vypracovala podle našich představ a zároveň přidala několik vlastních zajímavých nápadů. Díky svým znalostem a zkušenostem umí navrhnout a doporučit i méně obvyklé rostliny, na které bych sama nepřišla. Návrh byl pojatý velmi komplexně, kromě výsadby do něj Anežka zapracovala také prvky vhodné pro děti a možnosti jejich úprav do budoucna. Už jsme Plevel design doporučili příbuzným.",
      name: "Kateřina Maslowská",
    },
    {
      heading: "",
      text: "Anežka Vás ohromí. Je rozhodná, přímá, vtipná a umí poslouchat, co si ve své zahradě přejete a co ne. Má dobré postřehy a kvalifikovaně Vám poradí.",
      name: "Magdalena Křížková",
    },
    {
      heading: "",
      text: "Oceňuju individuální přístup Anežky, prošla s námi celou zahradu a poradila řešení jednotlivých problémů. Doporučila konkrétní rostliny vhodné na různá stanoviště případně úpravu stávajících.",
      name: "Dana Kohl",
    },
    {
      heading: "",
      text: "Tvořivost, odbornost, důkladnost, spolehlivost, ochota, skvělá spolupráce... Paní Horynová je odborník ve svém oboru a ještě k tomu lidsky milá. Jsem ráda za dlouhodobou spolupráci s naším spolkem Mondík.",
      name: "Jiřina Botošová",
    },
    {
      heading: "",
      text: "Anežka nám pomohla učesat náš návrh zahrady. Poradila vhodnou novou výsadbu, nejvhodnější umístění i péči. Poradila, jak vyzrát na problémy v zahradě, které nás trápily a že jich na výsušném svahu je...Zpracovala nám plánek koupacího jezírka, na který bychom si sami netroufli.",
      name: "Lucie Pokorná",
    },
    {
      heading: "",
      text: "S Anežkou je skvělá spolupráce. Zahradu nám navrhla s citem a ohledem na naše přání a potřeby. Realizovali jsme i věci, o kterých jsme ani netušili, že si je přejeme a teď jsme z nich nadšení. Neocenitelné jsou také průběžné rady a konzultace, bez kterých bychom realizaci těžko zvládli.",
      name: "Zuzana Štrynclová",
    },
  ];

  const [openProject, setOpenProject] = useState(null);
  const [formStatus, setFormStatus] = useState("idle"); // idle | sending | success | error

  // Odeslání formuláře: zkusíme Formspree přes fetch. Pokud selže (chyba sítě,
  // server, blokování), otevřeme uživateli mailto klient s předvyplněnou
  // zprávou jako fallback. Pokud projde, ukážeme děkovací hlášku.
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    setFormStatus("sending");
    try {
      const r = await fetch(form.action, {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" },
      });
      if (!r.ok) throw new Error("Network response was not ok");
      setFormStatus("success");
      form.reset();
    } catch (err) {
      setFormStatus("error");
      const name = data.get("name") || "";
      const contact = data.get("contact") || "";
      const location = data.get("location") || "";
      const service = data.get("service") || "";
      const message = data.get("message") || "";
      const subject = encodeURIComponent("Poptávka z webu — " + name);
      const body = encodeURIComponent(
        "Jméno: " + name +
        "\nKontakt: " + contact +
        "\nLokalita pozemku: " + location +
        "\nO co mám zájem: " + service +
        "\n\nZpráva:\n" + message
      );
      window.location.href =
        "mailto:anezka@pleveldesign.cz?subject=" + subject + "&body=" + body;
    }
  };


  // Kompaktní vzdělání — 6 nejsilnějších milníků pro timeline.
  const eduItems = [
    ["2013–2015", "Ing. Ekologické zemědělství, ČZU + Wageningen"],
    ["2015", "PDC certifikace permakultury, Wageningen University"],
    ["2023", "Arboristická certifikace ČCA"],
    ["2023", "Spolupráce se Sázíme stromy"],
    ["2024", "Dlouhodobá koncepce zeleně, Trojanovice"],
    ["2025", "Založení Plevel design s.r.o."],
  ];

  // "Co pro vás můžu udělat" — odrážky
  const aboutListItems = [
    "Návrh zahrady nebo krajiny – od první myšlenky po výsadbový plán",
    "Konzultace na místě – když nevíte, jak začít, nebo kde jste uvízli",
    "Odborný dozor při realizaci – aby výsledek odpovídal návrhu",
    "Osazovací plány pro obce – nové aleje, oživení stávající zeleně v intravilánu, dotační podklady",
    "Pomoc s dotací – osazovací plán a odborné podklady připravené tak, aby prošly",
    "Spolupráce se Sázíme stromy – pro obce, které chtějí jednoduché řešení rovnou s podporou pro realizaci",
  ];

  // Vybrané projekty — highlight reel (foto se doplní později)
  const featured = [
    {
      title: "Zeleň podél cyklostezky",
      subtitle: "4 km výsadby",
      desc: "Návrh a realizace výsadbového pásu podél čtyřkilometrové cyklostezky včetně náhradní výsadby. Projekt tohoto rozsahu vyžaduje přesnou druhovou skladbu, koordinaci s realizační firmou i dlouhodobé myšlení – stromy podél cest jsou tady za dvacet let, ne za dvě sezóny.",
      photo: null,
    },
    {
      title: "Farma pod Velkým Hájem, Praha-Krč",
      subtitle: "Zahradně-architektonická studie",
      desc: "Koncepční studie pro největší komunitní zahradu v České republice. Projekt v městském prostředí s důrazem na sdílení, jedlou krajinu a dlouhodobou udržitelnost. Práce na takovém místě znamená navrhovat pro desítky lidí najednou – s různými potřebami, rytmy a představami o tom, jak zahrada má vypadat.",
      photo: "/photos/portfolio/2025 -X Komunitní zahrada Pod Velkým Hájem Praha Krč/20251006_104114.jpg",
    },
    {
      title: "Revitalizace veřejného prostranství, Přerov",
      subtitle: "Projektová dokumentace",
      desc: "Zpracování projektové dokumentace pro revitalizaci veřejného prostranství ve městě. Práce pro větší municipality znamená pohybovat se mezi požadavky úřadů, očekáváními obyvatel a tím, co místu skutečně prospěje. Výsledkem není jen hezčí prostor – ale místo, které má šanci fungovat dlouhodobě bez zbytečné údržby.",
      photo: null,
    },
  ];

  // Setřídit reference podle délky (kratší = silnější výpovědi nahoru)
  const sortedRefs = [...reference].sort((a, b) => a.text.length - b.text.length);

  // Iniciály pro avatar
  const initials = (name) =>
    (name || "")
      .split(" ")
      .map((w) => w.charAt(0))
      .join("")
      .slice(0, 2)
      .toUpperCase();

  return (
    <div className="site">
      <Navigation />

      {/* ======================= HERO ======================= */}
      <header className="hero" id="hero">
        <h1 className="sr-only">
          Plevel design — návrhy přírodních zahrad a permakultura, Anežka Horynová
        </h1>
        <Pampeliska
          variant="seedhead"
          size={260}
          opacity={0.07}
          className="watermark watermark--tr"
        />
        <div className="hero__grid">
          <div className="hero__left">
            {/* Dekorativní letící pampelišková semínka — vyplní vizuální
                prázdnotu kolem textu, drží motiv loga. Mimo osy textu. */}
            <Pampeliska
              variant="seed"
              size={58}
              color="#8b6240"
              opacity={0.75}
              className="hero__seed hero__seed--1"
            />
            <Pampeliska
              variant="seed"
              size={50}
              color="#8b6240"
              opacity={0.7}
              className="hero__seed hero__seed--3"
            />

            <img className="hero__logo" src={Logo} alt="Plevel design" />
            <p className="hero__tagline">
              Přírodní design pro předzahrádku i celý katastr obce
            </p>
            <p className="hero__pitch">
              Navrhuju zahrady a veřejnou zeleň pro lidi, kteří chtějí víc než
              hezký výsledek na papíře. Projekty, které fungují za deset let
              stejně dobře jako dnes.
            </p>
            <div className="hero__ctas">
              <a className="btn btn--primary" href="#Kontakt">
                Sjednat konzultaci
              </a>
              <a className="btn btn--outline" href="#Portfolio">
                Prohlédnout portfolio
              </a>
            </div>
          </div>
          <div
            className="hero__photo"
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/preview.JPG)` }}
            role="img"
            aria-label="Ukázka přírodní zahrady navržené Plevel design"
          />
        </div>

        {/* Trust strip — drobné info na sage proužku jako barevný předěl. */}
        <div className="hero__trust">
          <span><strong>přes 14</strong> let praxe</span>
          <span><strong>100+</strong> projektů</span>
          <span className="hero__trust-cert">PDC · Sázíme stromy · ČCA</span>
        </div>
      </header>

      {/* Decentní předěl mezi hero a obsahem */}
      <div className="section-divider" aria-hidden="true">
        <Pampeliska variant="seed" size={28} color="#8b6240" opacity={0.55} />
      </div>

      {/* ======================= O MNĚ ======================= */}
      <section id="O mně" className="section section--cream">
        <Pampeliska
          variant="seedhead"
          size={340}
          opacity={0.05}
          className="watermark watermark--tr"
        />
        <div className="container">
          <p className="eyebrow">O mně</p>
          <h2 className="section-heading">
            Plevel má v přírodě nezastupitelnou funkci. Můj přístup také.
          </h2>
          <div className="about__grid">
            <div>
              <img
                className="about__portrait"
                src={about[0].photo}
                alt="Ing. Anežka Horynová — návrhářka přírodních zahrad"
              />
              <div className="about__badges">
                <div>
                  <div className="about__badge-num">PDC</div>
                  <div className="about__badge-label">permakultura · Wageningen</div>
                </div>
                <div>
                  <div className="about__badge-num">ČCA</div>
                  <div className="about__badge-label">arboristika · ČR</div>
                </div>
                <div>
                  <div className="about__badge-num">PřF UK</div>
                  <div className="about__badge-label">Bc. biologie</div>
                </div>
                <div>
                  <div className="about__badge-num">ČZU</div>
                  <div className="about__badge-label">Ing. zemědělství</div>
                </div>
                <div>
                  <div className="about__badge-num">WUR</div>
                  <div className="about__badge-label">Erasmus · Nizozemí</div>
                </div>
              </div>
            </div>
            <div className="about__story">
              <p style={{ fontFamily: "'Amatic SC', cursive", fontSize: "1.6rem", color: "#8b6240", margin: "0 0 4px" }}>
                Ing. Anežka Horynová
              </p>
              {about.map((a, i) => (
                <p key={i}>{a.text}</p>
              ))}
            </div>
          </div>

          {/* Co pro vás můžu udělat */}
          <div className="about__block">
            <h3 className="about__block-title">{listofservice[0].subheading}</h3>
            <ul className="tidy-list">
              {aboutListItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          {/* Jak funguje spolupráce */}
          <div className="about__block">
            <h3 className="about__block-title">{colab[0].subheading}</h3>
            {colab[0].text.split("\n\n").map((p, i) => (
              <p key={i} style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#4a4540", maxWidth: "780px", marginTop: i === 0 ? 0 : "12px" }}>
                {p}
              </p>
            ))}
          </div>

          {/* Co stojí za mým přístupem */}
          <div className="about__block">
            <h3 className="about__block-title">{experience[0].subheading}</h3>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#4a4540", maxWidth: "780px", margin: "0 0 12px" }}>
              Vystudovala jsem ekologické zemědělství na ČZU, část studia jsem
              strávila na Wageningen University v Nizozemsku – jedné z předních
              světových škol v oboru. Certifikaci z permakultury (PDC) jsem
              získala přímo tam. V roce 2023 jsem doplnila vzdělání o
              arboristiku – certifikát ČCA, který mi umožňuje odborně
              posuzovat i ošetřovat stromy.
            </p>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#4a4540", maxWidth: "780px", margin: "0 0 20px" }}>
              Nejdelší spolupráci mám s obcí Trojanovice, kde od roku 2024
              vedu dlouhodobou koncepci zeleně včetně realizace a údržby.
              Právě takhle spolupráce funguje nejlépe – když mám místo v péči
              v čase, ne jen na papíře.
            </p>
            <ul className="timeline">
              {eduItems.map(([year, label], i) => (
                <li key={i}>
                  <span className="timeline__year">{year}</span>
                  {label}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ======================= VYBRANÉ PROJEKTY ======================= */}
      <section id="Vybrané projekty" className="section section--cream-dark">
        <div className="container">
          <p className="eyebrow">Na čem jsem pracovala</p>
          <h2 className="section-heading">Vybrané projekty</h2>
          <div className="featured-list">
            {featured.map((p, i) => (
              <article className="featured-card" key={i}>
                <div className="featured-card__media">
                  {p.photo ? (
                    <img src={p.photo} alt={p.title} loading="lazy" />
                  ) : (
                    <span className="featured-card__media-empty">
                      [ fotka projektu se doplní ]
                    </span>
                  )}
                </div>
                <div className="featured-card__body">
                  <p className="featured-card__subtitle">{p.subtitle}</p>
                  <h3 className="featured-card__title">{p.title}</h3>
                  <p className="featured-card__desc">{p.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ======================= SLUŽBY ======================= */}
      <section id="Služby Ceník" className="section section--cream">
        <div className="container">
          <div className="intro-box">{whyplevel[0].text}</div>

          <p className="eyebrow">Služby a ceník</p>
          <h2 className="section-heading">Co pro vaši zahradu zvládnu</h2>
          <div className="cards-grid">
            {service.map((s, i) => (
              <div className="service-card" key={i}>
                <h3 className="service-card__title">{s.heading}</h3>
                <p className="service-card__text">{s.text}</p>
              </div>
            ))}
            <div className="service-card service-card--cta">
              <h3 className="service-card__title">Nevíte, co potřebujete?</h3>
              <p className="service-card__text">
                Pošlete pár slov o pozemku. Navrhneme spolu, kde začít.
              </p>
              <a className="btn btn--light" href="#Kontakt">
                Napsat Anežce
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ======================= PORTFOLIO ======================= */}
      <section id="Portfolio" className="section section--cream-dark">
        <Pampeliska
          variant="seedhead"
          size={300}
          opacity={0.05}
          className="watermark watermark--bl"
        />
        <div className="container">
          <p className="eyebrow">Portfolio</p>
          <h2 className="section-heading">Jak to vypadá v praxi</h2>
          <div className="portfolio-grid">
            {portfolio.map((p, i) => (
              <ProjectCard
                key={i}
                project={p}
                index={i}
                onOpen={setOpenProject}
              />
            ))}
          </div>
        </div>
      </section>

      {openProject !== null && (
        <div
          className="pf-modal"
          onClick={() => setOpenProject(null)}
          role="dialog"
          aria-modal="true"
        >
          <div
            className="pf-modal__inner"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="pf-modal__close"
              aria-label="Zavřít"
              onClick={() => setOpenProject(null)}
            >
              ×
            </button>
            <h3 className="pf-modal__title">
              {portfolio[openProject].location}
            </h3>
            <p className="pf-modal__meta">
              {portfolio[openProject].photo.length} fotografií
            </p>
            <Gallery
              items={portfolio[openProject].photo}
              projectName={portfolio[openProject].location}
            />
            <p className="pf-modal__desc">
              {portfolio[openProject].description}
            </p>
          </div>
        </div>
      )}

      {/* ======================= REFERENCE ======================= */}
      <section id="Reference" className="section section--cream">
        <div className="container">
          <p className="eyebrow">Co říkají klienti</p>
          <h2 className="section-heading">Spolupráce, která trvá</h2>
          <div className="reference-grid">
            {sortedRefs.map((r, i) => (
              <div className="reference-card" key={i}>
                <span className="reference-card__quote-mark">„</span>
                <p className="reference-card__text">{r.text}</p>
                <div className="reference-card__author">
                  <div className="reference-card__avatar">
                    {initials(r.name)}
                  </div>
                  <span className="reference-card__name">{r.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ======================= KONTAKT ======================= */}
      <section id="Kontakt" className="section section--olive">
        <div className="container">
          <div className="contact__grid">
            <div>
              <p className="eyebrow">Sjednat konzultaci</p>
              <h2 className="section-heading">Pojďme to spolu navrhnout.</h2>
              <p style={{ marginTop: 0, marginBottom: "20px", opacity: 0.9 }}>
                Nevadí, když ještě nevíte přesně, co chcete. Napište mi, co
                máte a co vás trápí – a já vám napíšu zpět do dvou pracovních
                dnů.
              </p>
              <form
                className="contact-form"
                action="https://formspree.io/f/xykvlgwj"
                method="POST"
                onSubmit={handleSubmit}
              >
                <label>
                  Jméno a příjmení *
                  <input type="text" name="name" required />
                </label>
                <label>
                  E-mail nebo telefon *
                  <input type="text" name="contact" required />
                </label>
                <label>
                  Lokalita pozemku
                  <input type="text" name="location" placeholder="např. Frýdek-Místek" />
                </label>
                <label>
                  O co máte zájem?
                  <select name="service">
                    <option>Návrh přírodní zahrady</option>
                    <option>Konzultace</option>
                    <option>Realizace</option>
                    <option>Osazovací plán pro obec</option>
                    <option>Řez stromů</option>
                    <option>Jiné / nevím</option>
                  </select>
                </label>
                <label className="full">
                  Napište mi pár slov o vašem projektu *
                  <textarea name="message" rows="5" required />
                </label>
                {formStatus === "success" && (
                  <p
                    className="full"
                    style={{
                      gridColumn: "1 / 3",
                      background: "rgba(245, 239, 229, 0.18)",
                      border: "1px solid rgba(245, 239, 229, 0.35)",
                      borderRadius: "6px",
                      padding: "12px 14px",
                      margin: 0,
                    }}
                    role="status"
                  >
                    Děkuji za zprávu! Ozvu se do dvou pracovních dnů.
                  </p>
                )}
                {formStatus === "error" && (
                  <p
                    className="full"
                    style={{
                      gridColumn: "1 / 3",
                      background: "rgba(245, 239, 229, 0.18)",
                      border: "1px solid rgba(245, 239, 229, 0.35)",
                      borderRadius: "6px",
                      padding: "12px 14px",
                      margin: 0,
                    }}
                    role="alert"
                  >
                    Odeslání zatím selhalo. Otevřu vám e-mailového klienta
                    s předvyplněnou zprávou — pokud se neotevře, napište mi
                    prosím na{" "}
                    <a href="mailto:anezka@pleveldesign.cz" style={{ color: "var(--cream)" }}>
                      anezka@pleveldesign.cz
                    </a>
                    .
                  </p>
                )}
                <button
                  type="submit"
                  className="btn btn--light full"
                  disabled={formStatus === "sending"}
                  style={
                    formStatus === "sending"
                      ? { opacity: 0.7, cursor: "wait" }
                      : undefined
                  }
                >
                  {formStatus === "sending" ? "Odesílám…" : "Napsat Anežce"}
                </button>
              </form>
            </div>

            <div className="contact-info">
              <p className="contact-info__name">Ing. Anežka Horynová</p>
              <p style={{ margin: "0 0 14px", opacity: 0.8, fontSize: "0.92rem" }}>
                Plevel design s.r.o. · zakladatelka
              </p>
              <div className="contact-info__row">
                <span aria-hidden="true">✉</span>
                <a href="mailto:anezka@pleveldesign.cz">anezka@pleveldesign.cz</a>
              </div>
              <div className="contact-info__row">
                <span aria-hidden="true">☎</span>
                <a href="tel:+420721383618">+420 721 383 618</a>
              </div>
              <div className="contact-info__row">
                <span aria-hidden="true">▸</span>
                <a
                  href="https://www.facebook.com/pleveldesign"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  facebook.com/pleveldesign
                </a>
              </div>
              <div className="contact-info__row">
                <span aria-hidden="true">⚑</span>
                <span>Kozlovice (okres Frýdek-Místek)</span>
              </div>
              <hr className="contact-info__divider" />
              <p style={{ fontSize: "0.86rem", lineHeight: 1.6, opacity: 0.85, margin: 0 }}>
                <strong>Oblast působnosti:</strong> pracuji po celé ČR.
                Vzdálenější lokality jen trochu víc plánuji dopředu – ráda
                spojím více návštěv do jednoho výjezdu.
              </p>
              <hr className="contact-info__divider" />
              <p style={{ fontSize: "0.78rem", lineHeight: 1.6, opacity: 0.75, margin: "0 0 8px" }}>
                <strong>Fakturační údaje OSVČ:</strong> Ing. Anežka Horynová,
                739 47 Kozlovice 178, IČ 05538351, neplátce DPH,
                ČÚ 1567646018/3030 (Air bank).
              </p>
              <p style={{ fontSize: "0.78rem", lineHeight: 1.6, opacity: 0.75, margin: 0 }}>
                <strong>Fakturační údaje Plevel design s.r.o.:</strong>
                739 47 Kozlovice 178, IČ 09565761, DIČ CZ09565761 (plátce
                DPH), ČÚ 3353382028/3030 (Air bank).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ======================= PATIČKA ======================= */}
      <footer className="footer">
        <Pampeliska
          variant="seedhead"
          size={260}
          color="#f5efe5"
          opacity={0.09}
          className="watermark watermark--bl"
        />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <img className="footer__logo" src={LogoWhite} alt="Plevel design" />
          <p className="footer__tagline">
            Přírodní design pro předzahrádku i celý katastr obce
          </p>
          <div className="footer__bottom">
            <span>
              anezka@pleveldesign.cz · +420 721 383 618 · Kozlovice (okr.
              Frýdek-Místek)
            </span>
            <span>© 2026 Plevel design s.r.o. · IČ 09565761</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
